const VerifiedResellerIconSmall = ({ ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="22" height="22" rx="11" fill="#2882ED" />
      <path
        d="M6.91663 11.583L9.24996 13.9163L15.0833 8.08301"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VerifiedResellerIconSmall;
